(function () {
  try {
    if (window.__tvPromoInit) return;
    window.__tvPromoInit = true;

    function two(n) { return n < 10 ? '0' + n : '' + n; }
    function fmtLeft(ms) {
      var s = Math.max(0, Math.floor(ms / 1000));
      var d = Math.floor(s / 86400);
      var h = Math.floor((s % 86400) / 3600);
      var m = Math.floor((s % 3600) / 60);
      if (d > 0) return d + 'd ' + h + 'h ' + m + 'm';
      return h + ':' + two(m) + ':' + two(s % 60);
    }

    function endRoot(el) {
      var root = el.closest ? el.closest('[data-tv-promo-root]') : null;
      if (root) root.hidden = true;
    }

    function segParts(ms) {
      var s = Math.max(0, Math.floor(ms / 1000));
      return [two(Math.floor(s / 86400)), two(Math.floor((s % 86400) / 3600)), two(Math.floor((s % 3600) / 60)), two(s % 60)];
    }
    function segHtml(ms) {
      var v = segParts(ms), labels = ['days', 'hrs', 'min', 'sec'], colon = '<span class="tv-promo-colon" aria-hidden="true">:</span>';
      return v.map(function (n, i) { return '<span class="tv-promo-seg"><b>' + n + '</b><small>' + labels[i] + '</small></span>'; }).join(colon);
    }
    function setSegs(nums, ms) {
      var v = segParts(ms);
      for (var i = 0; i < nums.length && i < 4; i++) if (nums[i].textContent !== v[i]) nums[i].textContent = v[i];
    }

    function setTiles(nums, ms) {
      var s = Math.max(0, Math.floor(ms / 1000));
      var v = [two(Math.floor(s / 86400)), two(Math.floor((s % 86400) / 3600)), two(Math.floor((s % 3600) / 60)), two(s % 60)];
      for (var i = 0; i < nums.length && i < 4; i++) setText(nums[i], v[i]);
    }
    function setText(node, txt) {
      var t = node.firstChild;
      if (!t) node.textContent = txt;
      else if (t.nodeValue !== txt) t.nodeValue = txt;
    }

    function bindTimer(el) {
      if (el.__tvPromoBound) return;
      el.__tvPromoBound = true;
      var endsAt = Date.parse(el.getAttribute('data-tv-promo-end') || '');
      var tpl = el.getAttribute('data-tv-promo-tpl') || 'Ends in [time]';
      var format = el.getAttribute('data-tv-promo-format');
      var segments = format === 'segments';
      if (!endsAt) { if (format === 'tiles') { el.hidden = true; endRoot(el); } return; }

      var timer = null;
      function hide() { el.hidden = true; el.textContent = ''; endRoot(el); }
      function schedule() {
        if (timer) { clearTimeout(timer); timer = null; }
        if (!el.isConnected) return;
        var left = endsAt - Date.now();
        if (left <= 0) { hide(); return; }
        if (format === 'tiles') {
          setTiles(el.querySelectorAll('[data-tv-tile]'), left);
          var tsr = el.querySelector('.tv-promo-sr');
          if (tsr) setText(tsr, tpl.replace('[time]', fmtLeft(left)));
          el.hidden = false;
          timer = setTimeout(schedule, 1000 - (left % 1000) + 20);
          return;
        }
        if (segments) {
          if (!(el.__tvSegNums && el.__tvSegNums.length && el.contains(el.__tvSegNums[0]))) {
            el.innerHTML = tpl.replace('[time]', '<span class="tv-promo-segs" aria-hidden="true">' + segHtml(left) + '</span>') + '<span class="tv-promo-sr"></span>';
            el.__tvSegNums = el.querySelectorAll('.tv-promo-seg b');
            el.__tvSr = el.querySelector('.tv-promo-sr');
          }
          setSegs(el.__tvSegNums, left);
          var sr = tpl.replace('[time]', fmtLeft(left));
          if (el.__tvSr && el.__tvSr.textContent !== sr) el.__tvSr.textContent = sr;
          el.hidden = false;
          timer = setTimeout(schedule, 1000);
          return;
        }
        var txt = tpl.replace('[time]', fmtLeft(left));
        if (el.textContent !== txt) el.textContent = txt;
        el.hidden = false;
        timer = setTimeout(schedule, left < 86400000 ? 1000 : 30000);
      }
      el.__tvPromoKick = schedule;
      schedule();
    }

    function bindCopy(btn) {
      if (btn.__tvPromoBound) return;
      btn.__tvPromoBound = true;
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-code') || '';
        var label = btn.querySelector('[data-tv-promo-copylabel]');
        var idle = label ? label.textContent : '';
        function flash() {
          btn.classList.add('copied');
          if (label) label.textContent = btn.getAttribute('data-copied-label') || 'Copied';
          setTimeout(function () {
            btn.classList.remove('copied');
            if (label) label.textContent = idle;
          }, 1600);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(flash, flash);
        } else { flash(); }
      });
    }

    function scan() {
      var t = document.querySelectorAll('[data-tv-promo-end]');
      for (var i = 0; i < t.length; i++) bindTimer(t[i]);
      var c = document.querySelectorAll('[data-tv-promo-copy]');
      for (var j = 0; j < c.length; j++) bindCopy(c[j]);
    }

    var pending = null;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; scan(); }, 200);
    });

    function start() {
      scan();
      mo.observe(document.body, { childList: true, subtree: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) return;
      var list = document.querySelectorAll('[data-tv-promo-end]');
      for (var i = 0; i < list.length; i++) if (list[i].__tvPromoKick) list[i].__tvPromoKick();
    });
  } catch (e) { }
})();
